import StudentsService from "services/StudentsService";

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const getStudents = createAsyncThunk(
    "students/getAll",
    async (_, { rejectWithValue }) => {
        try {
            const response = await StudentsService.getStudents();
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const getStudentById = createAsyncThunk(
    "students/getStudentById",
    async (studentId, { rejectWithValue }) => {
        try {
            const response = await StudentsService.getStudentById(studentId);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const createStudent = createAsyncThunk(
    "students/createStudent",
    async (data, { rejectWithValue }) => {
        try {
            const response = await StudentsService.createStudent(data);
            return response.data.student;
        } catch (error) {
            return rejectWithValue(error.response.data.message || "Erreur");
        }
    }
);

export const updateStudentById = createAsyncThunk(
    "students/updateStudentById",
    async ({ studentId, data }, { rejectWithValue }) => {
        try {
            const response = await StudentsService.updateStudent(
                studentId,
                data
            );
            return response.data.student;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Erreur");
        }
    }
);

export const deleteStudentById = createAsyncThunk(
    "students/deleteStudentById",
    async (id, { rejectWithValue }) => {
        try {
            // TODO: this is supposed to return the deleted student id, but the API returns only a status message
            await StudentsService.deleteStudentById(id);
            return id;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const validateStudent = createAsyncThunk(
    "students/validateStudent",
    async (id, { rejectWithValue }) => {
        try {
            await StudentsService.validateStudent(id);
            return id;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const banStudent = createAsyncThunk(
    "students/banStudent",
    async (id, { rejectWithValue }) => {
        try {
            await StudentsService.banStudent(id);
            return id;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const resetStudentPasswordByAdmin = createAsyncThunk(
    "students/resetStudentPasswordByAdmin",
    async (id, { rejectWithValue }) => {
        try {
            const response = await StudentsService.resetPasswordByAdmin(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Erreur");
        }
    }
);

export const updateStudentFormation = createAsyncThunk(
  "students/updateStudentFormation",
  async ({ studentFormationId, data }, { rejectWithValue }) => {
    try {
      const response = await StudentsService.updateStudentFormation(
        studentFormationId,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response || "Erreur");
    }
  }
);


const initialState = {
    students: [],
    student: null,
    loading: false,
    error: null,
};

const studentsSlice = createSlice({
    name: "students",
    initialState,
    reducers: {
        setStudents: (state, { payload }) => {
            state.students = payload;
        },
        setStudent: (state, { payload }) => {
            state.student = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },
    extraReducers: {
        [getStudents.pending]: (state) => {
            state.loading = true;
        },
        [getStudents.fulfilled]: (state, { payload }) => {
            state.students = payload;
            state.loading = false;
        },
        [getStudents.rejected]: (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        },
        [getStudentById.pending]: (state) => {
            state.loading = true;
        },
        [getStudentById.fulfilled]: (state, { payload }) => {
            state.student = payload;
            state.loading = false;
        },
        [getStudentById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [createStudent.pending]: (state, { payload }) => {
            state.loading = true;
        },
        [createStudent.fulfilled]: (state, { payload }) => {
            state.students.unshift(payload);
            state.loading = false;
        },
        [createStudent.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [updateStudentById.pending]: (state) => {
            state.loading = true;
        },
        [updateStudentById.fulfilled]: (state, { payload }) => {
            state.students = state.students.map((student) =>
                student._id === payload._id ? payload : student
            );
            state.loading = false;
        },
        [updateStudentById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [deleteStudentById.pending]: (state) => {
            state.loading = true;
        },
        [deleteStudentById.fulfilled]: (state, { payload }) => {
            state.students = state.students.filter(
                (student) => student._id !== payload
            );
            state.loading = false;
        },
        [deleteStudentById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [validateStudent.pending]: (state) => {
            state.loading = true;
        },
        [validateStudent.fulfilled]: (state, { payload }) => {
            state.students = state.students.map((student) =>
                student._id === payload
                    ? { ...student, isVerified: true }
                    : student
            );
            state.loading = false;
        },
        [validateStudent.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [banStudent.pending]: (state) => {
            state.loading = true;
        },
        [banStudent.fulfilled]: (state, { payload }) => {
            state.students = state.students.map((student) =>
                student._id === payload
                    ? { ...student, isBanned: true }
                    : student
            );
            state.loading = false;
        },
        [banStudent.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [resetStudentPasswordByAdmin.pending]: (state) => {
            state.loading = true;
        },
        [resetStudentPasswordByAdmin.fulfilled]: (state) => {
            state.loading = false;
        },
        [resetStudentPasswordByAdmin.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload;
        },
    },
});

export const { setStudents, setStudent, setLoading, setError } =
    studentsSlice.actions;

export default studentsSlice.reducer;
